// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".btnBox[data-v-462c60ed] {\n  text-align: center;\n  margin-top: 20px;\n}", ""]);
// Exports
module.exports = exports;
